export default "__VITE_ASSET__DYeZLqiG__"